export default "__VITE_ASSET__b7f6b83a__"